import "./icon.custom.objectPerson.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomObjectPersonProps = ComponentProps<"svg">
function IconCustomObjectPerson(props: IconCustomObjectPersonProps) {
  const { className, viewBox = "0 0 16 16", fill = "none", ...svgProps } = props

  return (
    <svg
      className={cn("objectPerson__svg", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect
        className="objectPerson__svg_main"
        x="3.19998"
        width="9.6"
        height="9.6"
        rx="4.8"
      />

      <path
        className="objectPerson__svg_second"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.92879 9.87753C1.64839 10.6187 0 12.7613 0 15.2889V16H16V15.2889C16 12.7613 14.3516 10.6187 12.0712 9.87753C11.0268 10.9147 9.58823 11.5556 8 11.5556C6.41177 11.5556 4.97321 10.9147 3.92879 9.87753Z"
      />
    </svg>
  )
}

export default IconCustomObjectPerson
